// import React from 'react';
import { RSAA } from 'redux-api-middleware';
import { REQUEST, SUCCESS, FAILURE } from '@/modules/Requests';

export const REQUEST_GET_PAST_WINNERS = 'REQUEST_GET_PAST_WINNERS';
export const CREATE_WINNER = 'CREATE_WINNER';
export const UPDATE_WINNER = 'UPDATE_WINNER';
export const GET_WINNER = 'GET_WINNER';
export const DELETE_WINNER = 'DELETE_WINNER';
export const WINNER_FORM = 'WINNER_FORM';
export const SAVE_WINNERS = 'SAVE_WINNERS';
export const REQUEST_GET_CHAMPIONS = 'REQUEST_GET_CHAMPIONS';
export const SET_CHAMPIONS_OLIMP_TYPE = 'SET_CHAMPIONS_OLIMP_TYPE';

export const CLEAR_SAVE_RESPONSE = 'CLEAR_SAVE_RESPONSE';

export const clearSaveResponseAction = () => ({
  type: CLEAR_SAVE_RESPONSE,
});

export const setChampionsOlimpType = OlimpType => ({
  type: SET_CHAMPIONS_OLIMP_TYPE,
  payload: OlimpType,
});

const host = process.env.BACKEND_URL;

// Init state
const initialState = {
  list: [],
  pastWinners: [],
  champions: {},
  recentChampions: {},
  olimpType: 'online',
  opened: null,
  saveResponse: null,
  loading: false,
  error: null,
};

const winnersReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST:
      if (action.meta?.request === SAVE_WINNERS) {
        return {
          ...state,
          loading: true,
          error: null,
          saveResponse: null, // Clear previous response
        };
      }
      return state;

    case SUCCESS:
      if (action.meta?.request === SAVE_WINNERS) {
        return {
          ...state,
          loading: false,
          saveResponse: action.payload, // Store the response data
          error: null,
        };
      }
      if (action.meta?.request === REQUEST_GET_PAST_WINNERS) {
        return {
          ...state,
          loading: false,
          pastWinners: action.payload,
          error: null,
        };
      }

      if (action.meta?.request === REQUEST_GET_CHAMPIONS) {
        const { scope, olimpType } = action.meta;
        if (scope === 'recent') {
          return {
            ...state,
            recentChampions: {
              ...state.recentChampions,
              [olimpType]: action.payload[0] || null,
            },
          };
        }
        return {
          ...state,
          champions: {
            ...state.champions,
            [olimpType]: action.payload,
          },
        };
      }

      return state;

    case FAILURE:
      if (action.meta?.request === SAVE_WINNERS) {
        return {
          ...state,
          loading: false,
          error: action.payload,
          saveResponse: null,
        };
      }
      return state;
    case CLEAR_SAVE_RESPONSE:
      return {
        ...state,
        saveResponse: null,
      };

    case SET_CHAMPIONS_OLIMP_TYPE:
      return {
        ...state,
        olimpType: action.payload,
      };

    default:
      return state;
  }
};

// Actions

// сохраняем 0, 1 места из результатов в winners
export const fetchSaveWinners = (olimpicId = null) => ({
  [RSAA]: {
    endpoint: `${host}/winners/save`,
    method: 'POST',
    body: JSON.stringify({ olimpicId }),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: SAVE_WINNERS,
      },
    })),
  },
});

export const fetchPastWinners = () => ({
  [RSAA]: {
    endpoint: `${host}/winners/list`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_GET_PAST_WINNERS,
      },
    })),
  },
});

export const fetchCreateWinner = form => ({
  [RSAA]: {
    endpoint: `${host}/winners/`,
    method: 'POST',
    body: JSON.stringify(form),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: CREATE_WINNER,
      },
    })),
  },
});

export const fetchWinner = id => ({
  [RSAA]: {
    endpoint: `${host}/winners/winner/${id}`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: GET_WINNER,
      },
    })),
  },
});

export const fetchUpdateWinner = (id, form) => ({
  [RSAA]: {
    endpoint: `${host}/winners/edit/${id}`,
    method: 'POST',
    body: JSON.stringify(form),
    headers: { 'Content-Type': 'application/json' },
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: UPDATE_WINNER,
      },
    })),
  },
});

export const fetchDeleteWinner = id => ({
  [RSAA]: {
    endpoint: `${host}/winners/delete/${id}`,
    method: 'DELETE',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: 'DELETE_WINNER',
      },
    })),
  },
});

// только 0 места для Уголка
export const fetchChampions = (type, scope = 'all') => ({
  [RSAA]: {
    endpoint: `${host}/winners/champions?type=${type}&scope=${scope}`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(t => ({
      type: t,
      meta: {
        request: REQUEST_GET_CHAMPIONS,
        scope,
        olimpType: type,
      },
    })),
  },
});

export default winnersReducer;
